export default __webpack_public_path__ + "static/media/icon-add-circle-solid.190e5268.svg";